/** Nombre de questions retenues pour la flèche du haut. */
export const MAX_QUERIES = 50;

/**
 * Questions déjà posées, rappelées avec ↑ / ↓ comme dans un terminal. La saisie en cours est mise de côté au
 * premier ↑ et revient au ↓ qui dépasse la plus récente : une flèche du haut par mégarde ne perd rien.
 */
export class QueryHistory {
  /** -1 : saisie en cours ; 0 : la question la plus récente ; 1 : celle d'avant… */
  private index = -1;
  private draft = "";

  /** `entries` : de la plus ancienne à la plus récente. */
  constructor(private entries: string[] = []) {}

  get navigating(): boolean {
    return this.index !== -1;
  }

  /** Question envoyée : ajoutée en dernier (sans doublon consécutif), la navigation repart de la saisie. */
  push(text: string): string[] {
    const query = text.trim();
    this.reset();
    if (!query) return this.entries;
    this.entries = [...this.entries.filter((q) => q !== query), query].slice(-MAX_QUERIES);
    return this.entries;
  }

  /** Question précédente, ou null s'il n'y en a pas (le texte reste tel quel). */
  up(current: string, entries = this.entries): string | null {
    if (!this.navigating) this.entries = entries;
    if (this.index >= this.entries.length - 1) return null;
    if (!this.navigating) this.draft = current;
    this.index++;
    return this.entries[this.entries.length - 1 - this.index];
  }

  /** Question suivante ; après la plus récente, la saisie mise de côté. Null hors navigation. */
  down(): string | null {
    if (!this.navigating) return null;
    this.index--;
    return this.index === -1 ? this.draft : this.entries[this.entries.length - 1 - this.index];
  }

  reset(): void {
    this.index = -1;
    this.draft = "";
  }
}
